import HorizontalLayout from '@/app/common/filters/surfaces/bar/HorizontalLayout';
import { createBarPills, createMobileBarPills } from '@/app/common/filters/surfaces/bar/resultsPills/createBarPills.ts';
import {
  createEvoBarPills,
  createEvoMobileBarPills,
} from '@/app/common/filters/variants/evo/pills/createEvoBarPills.ts';
import type { FilterPill } from '@/app/common/filters/surfaces/bar/pills/types.ts';
import type { FilterOrder } from '@/app/common/filters/session/filterOrder.ts';
import type { FiltersGroups } from '@/app/common/filters/core/filtersTypes.ts';
import type { SearchInfoData } from '@/app/search/types.ts';
import type { ProductsData } from '@/app/api/search/products/createProductsData.ts';
import type { TranslationFunction } from '@/app/components/translations/Translation.tsx';
import type { SearchParams } from '@/server/searchParams.ts';
import type { Language } from '@/domainLogic/index.ts';
import type { FilterFlags } from '@/app/common/filters/core/filterFlags.ts';

export type CreatePillsProps = {
  filtersGroups: FiltersGroups;
  searchInfoData: SearchInfoData;
  productsData: ProductsData;
  t: TranslationFunction;
  lang: Language;
  searchParams: SearchParams;
  filterOrder?: FilterOrder;
  config?: FilterFlags;
};

export type CreatePills = (props: CreatePillsProps) => FilterPill[];

export type FiltersModule = {
  createPills: CreatePills;
  createMobilePills: CreatePills;
  HorizontalLayoutComponent: typeof HorizontalLayout;
};

const currentFilters: FiltersModule = {
  createPills: createBarPills,
  createMobilePills: createMobileBarPills,
  HorizontalLayoutComponent: HorizontalLayout,
};

const evoFilters: FiltersModule = {
  createPills: createEvoBarPills,
  createMobilePills: createEvoMobileBarPills,
  HorizontalLayoutComponent: HorizontalLayout,
};

export const getFiltersModule = (useEvoFilters: boolean): FiltersModule =>
  useEvoFilters ? evoFilters : currentFilters;
